import React from 'react'
import Banner from "./Banner";
import Features from "../home/Features";
import CategoryProduct from './CategoryProduct';


export default function CategoryPage() {
  return (
    <>
      <Banner />
      <Features />
      <CategoryProduct />
    </>
  );
}

